module.exports = __webpack_public_path__ + "img/ic-trans.cd7df767.svg";